<template>
  <div>
    <transition name="slide-fade" appear>
      <b-row>
        <EncabezadoEstudiante/>
        <b-col cols="lg-6">
          <h2>Cambiar Contraseña</h2>
          <b-card>
            <b-form @submit.stop.prevent="validarCampos">
              <b-form-group description="Combine mayúsculas, minúsculas y números. Máximo 20 caracteres." label="Nueva Contraseña:" label-for="clave" :invalid-feedback="invalidClave" :valid-feedback="validClave" :state="stateClave">
                <b-form-input type="text" id="clave" v-model="clave" autocomplete="off" maxlength="20" :state="stateClave" trim ref="clave"></b-form-input>
                <span class="text-left text-danger">{{ contenidoMensajeClave }}</span>
              </b-form-group>

              <b-form-group description="Este correo se utilizará para enviarle información del sistema." label="Correo Electrónico:" label-for="correo">
                <b-form-input type="text" id="correo" v-model="correo" autocomplete="off" maxlength="100" ref="correo" @keypress="campoVacioCorreo"></b-form-input>
                <span class="text-left text-danger">{{ contenidoMensajeCorreo }}</span>
              </b-form-group>
              <b-button type="submit" class="btn btn-block mt-4 mb-4" variant="primary">Actualizar Contraseña</b-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
      
    </transition>
  </div>
</template>

<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'
  import EncabezadoEstudiante from '@/containers/EncabezadoEstudiante'

  export default {
    name: 'Dashboard',
    components: {
      EncabezadoEstudiante,
    },
    data () {
      return {
        clave: '',
        correo: '',
        contenidoMensajeClave: '',
        contenidoMensajeCorreo: '',
        datosActualizar: {}
      }
    },
    methods: {
      async actualizarClave() {
        
        let fechaAhora = new Date()
        let ano = fechaAhora.getFullYear()
        let mes = fechaAhora.getMonth() + 1
        let dia = fechaAhora.getDate()
        fechaAhora = ano + '-' + mes + '-' + dia

        this.datosActualizar.id = this.$store.state.idUsuario
        this.datosActualizar.clave = this.clave.trim()
        this.datosActualizar.correo = this.correo.toLowerCase()
        this.datosActualizar.fecha = fechaAhora
        this.datosActualizar.bd = this.$store.state.bdColegio
        await axios
        .put(CONFIG.ROOT_PATH + "usuarios/estudiante/clave", JSON.stringify(this.datosActualizar),{ headers: {"Content-Type": "application/json; charset=utf-8" }})
        .then(response => {
          if (response.data.error){
              this.mensajeEmergente("danger","Mensaje",response.data.mensaje)
          } else{
              this.mensajeEmergente("success","Mensaje",response.data.mensaje)
          }
        })
        .catch(err => {
          if (err.message === "Network Error")
            this.mensajeEmergente("danger","Error en la conexión","Se ha detectado que no hay conexión a internet, asegurese que tiene acceso e intente nuevamente.");
          else
            this.mensajeEmergente("danger","Mensaje","Se ha detectado un error inesperado!. Por favor intente hacer el proceso más tarde." + err.message);
        })
      },
      validarCampos() {
        if (this.clave == '') {
          this.verMensajeClave = true
          this.contenidoMensajeClave = 'Por favor digite la nueva contraseña'
          this.$refs.clave.focus()
        } else if (!this.validarCorreo()){
          this.verMensajeCorreo = true
          this.contenidoMensajeCorreo = 'El correo no es válido. Por favor digite el correo'
          this.$refs.correo.focus()
        } else {
          this.actualizarClave()
        }
      },
      validarCorreo() {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(this.correo)
      },
      campoVacioCorreo() {
        this.contenidoMensajeCorreo = ''
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
      }
    },
    beforeMount() {
      
    },
    computed: {
      stateClave() {
        this.contenidoMensajeClave = ''
        return this.clave.length >= 6 ? true : false
      },
      invalidClave() {
        if (this.clave.length > 6) {
          return ''
        } else if (this.clave.length > 0) {
          return 'La contraseña no es segura, ingrese mínimo 6 caracteres'
        } else {
          return ''
        }
      },
      validClave() {
        return this.stateClave === true ? 'Ahora la contraseña es segura' : ''
      }
    },
  }
</script>
